module.exports = __webpack_public_path__ + "img/refresh-ccw.b37b94cc.svg";